export default "/welcome/bg-line.png"